module.exports = __webpack_public_path__ + "media/icons/i-3-instances-828b2018.png";